<template>
  <div
    @click="viewDetailV2()"
    class="flex-row width__100"
    style="align-items: flex-start"
  >
    <div class="avt">
      <div
        class="
          avatar-fake
          font-size__small
          margin-right-10
          flex-row flex__center
        "
      >
        <span v-if="!!item.fromUserName">
          {{ buildShortName(item.fromUserName) }}
        </span>
      </div>
    </div>
    <div class="inf flex-col flex__left width__100 has-border__bottom">
      <notification-item-noti
        :vbNotificationView="item"
        v-if="isNotiNotification(item)"
      ></notification-item-noti>
      <notification-item-cv
        :vbNotificationView="item"
        v-else-if="isCVNotification(item)"
      ></notification-item-cv>
      <notification-item-vb
        :vbNotificationView="item"
        v-else-if="isVbNotificationV2(item)"
      ></notification-item-vb>
      <notification-item-banhanhtoi
        :vbNotificationView="item"
        v-else-if="item.messageType === MESSAGE_TYPE.INCOMING_BANHANH"
      ></notification-item-banhanhtoi>
      <notification-item-quahan-cv
        :vbNotificationView="item"
        v-else-if="item.messageType === MESSAGE_TYPE.CV_CANHBAOQUAHAN"
      ></notification-item-quahan-cv>
      <notification-item-ranking-score
        :vbNotificationView="item"
        v-else-if="item.messageType === MESSAGE_TYPE.RANKING_INSERTRANKINGSCORE"
      ></notification-item-ranking-score>

      <notification-item-hc-commands
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.CHI_DAO.BAO_CAO ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.GIA_HAN ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.DK_DEADLINE
        "
      ></notification-item-hc-commands>

      <notification-item-discuss
        :vbNotificationView="item"
        v-else-if="isDiscuss(item)"
      ></notification-item-discuss>

      <notification-item-news
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.ADDNEWS
        "
      ></notification-item-news>

      <notification-item-letter
        :vbNotificationView="item"
        v-else-if="isLetter(item)"
      ></notification-item-letter>

      <notification-item-document
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.DOCUMENT_APPROVE ||
          item.messageType === MESSAGE_TYPE.DOCUMENT_CREATE ||
          item.messageType === MESSAGE_TYPE.DOCUMENT_REJECT
        "
      ></notification-item-document>

      <notification-item-noti
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.ADDNOTI ||
          item.messageType === MESSAGE_TYPE.DELETE_USERNOTI
        "
      ></notification-item-noti>

      <notification-item-hanh-chinh
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.HANH_CHINH.DK_PHONGHOP ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.HUY_PHONG_HOP ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.CAP_NHAT_PHONG_HOP ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.PHE_DUYET_PHONG_HOP ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.TU_CHOI_PHONG_HOP ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.DIEU_XE.CAP_NHAT ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.DIEU_XE.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.DIEU_XE.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.DIEU_XE.DANG_KY ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.DIEU_XE.TU_CHOI ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.CAP_NHAT ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.DANG_KY ||
          item.messageType === MESSAGE_TYPE.HANH_CHINH.LICH_TUAN.TU_CHOI
        "
      ></notification-item-hanh-chinh>

      <notification-item-hc-commands-common
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.CHI_DAO.CREATE ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.UPDATE ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.YCBS ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.HUY ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.CHI_DAO.CHO_Y_KIEN
        "
      ></notification-item-hc-commands-common>

      <notification-item-hc-dieuxe
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.DIEU_XE.DANG_KY ||
          item.messageType === MESSAGE_TYPE.DIEU_XE.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.DIEU_XE.TU_CHOI ||
          item.messageType === MESSAGE_TYPE.DIEU_XE.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.DIEU_XE.CAP_NHAT
        "
      ></notification-item-hc-dieuxe>

      <notification-item-hc-case-flight
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.MAY_BAY.DANG_KY ||
          item.messageType === MESSAGE_TYPE.MAY_BAY.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.MAY_BAY.TU_CHOI ||
          item.messageType === MESSAGE_TYPE.MAY_BAY.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.MAY_BAY.CAP_NHAT
        "
      ></notification-item-hc-case-flight>

      <notification-item-hc-case-hotel
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.KHACH_SAN.DANG_KY ||
          item.messageType === MESSAGE_TYPE.KHACH_SAN.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.KHACH_SAN.TU_CHOI ||
          item.messageType === MESSAGE_TYPE.KHACH_SAN.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.KHACH_SAN.CAP_NHAT
        "
      ></notification-item-hc-case-hotel>

      <notification-item-hc-case-phonghop
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.PHONG_HOP.DANG_KY ||
          item.messageType === MESSAGE_TYPE.PHONG_HOP.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.PHONG_HOP.TU_CHOI ||
          item.messageType === MESSAGE_TYPE.PHONG_HOP.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.PHONG_HOP.CAP_NHAT
        "
      ></notification-item-hc-case-phonghop>

      <notification-item-hc-case-scn
        :vbNotificationView="item"
        v-else-if="
          item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.DANG_KY ||
          item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.PHE_DUYET ||
          item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.TU_CHOI ||
          item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.HUY_YEU_CAU ||
          item.messageType === MESSAGE_TYPE.SUA_CHUA_NHO.CAP_NHAT
        "
      ></notification-item-hc-case-scn>

      <div v-else v-html="handleAction(item.messageType, item)"></div>
      <div class="time font-size__small">
        <i class="font-size__small fas fa-clock"></i>
        {{ item.createTime | convertToLabelFilter }}
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
import convertToLabelFilter from "../../filters/convertToLabelFilter.js";
import constants from "../../constants";
import vbNotificationService from "../../services/vbNotificationService";
import moment from "moment";
import NotificationItemCv from "./notification-item-cv";
import NotificationItemVb from "./notification-item-vb";
import notificationMixin from "../../mixins/notificationMixin";
import NotificationItemQuahanCv from "./notification-item-quahan-cv";
import NotificationItemBanhanhtoi from "./notification-item-banhanhtoi";
import NotificationItemRankingScore from "./notification-item-ranking-score";
import NotificationItemNoti from "./notification-item-noti.vue";
import NotificationItemDiscuss from "./notification-item-discuss.vue";
import NotificationItemHanhChinh from "./notification-item-hanhchinh.vue";
import NotificationItemLetter from "./notification-item-letter.vue";
import NotificationItemNews from "./notification-item-news.vue";
import NotificationItemDocument from "./notification-item-document.vue";

export default {
  name: "notify-content",
  mixins: [notificationMixin],
  components: {
    NotificationItemRankingScore,
    NotificationItemBanhanhtoi,
    NotificationItemQuahanCv,
    NotificationItemVb,
    NotificationItemCv,
    NotificationItemNoti,
    NotificationItemDiscuss,
    NotificationItemHanhChinh,
    NotificationItemLetter,
    NotificationItemNews,
    NotificationItemDocument,
  },
  filters: { convertToLabelFilter },
  props: ["item"],
  data() {
    return {
      receiveText: "",
      MESSAGE_TYPE: constants.VB_NOTIFICATION.MESSAGE_TYPE,
      DISCUSS_TYPE: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.TAG_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.REPLY_COMMENT,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.APPROVE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DECLINE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.SEND_APPROVE_DISCUSS,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.REPORT_COMMENT,
      ],
      LETTERS: [
        constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.YEU_CAU,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.PHE_DUYET,
        constants.VB_NOTIFICATION.MESSAGE_TYPE.LETTER.TU_CHOI,
      ],
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    dataRow() {
      return JSON.parse(this.item.dataJson);
    },
    user() {
      return this.$store.getters.user;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },

  methods: {
    handleAction(action, object) {
      switch (action) {
        case "chuyenXuLy":
          return this.buildCXL(object);
        case "chuyenTiep":
          return this.buildCXL(object);
        case "thuHoi":
          return this.buildTuChoi(object);
        case "ketThuc":
          return this.buildTuChoi(object);
        case "tuChoi":
          return this.buildTuChoi(object);
        case "tuChoiBanHanh":
          return this.buildTuChoi(object);
        case "CC":
          return this.buildChuyenTiep(object);
        case "banhanh":
          return this.buildBHanh(object);
        case "choBanHanh":
          return this.buildTuChoi(object);
        case "tuChoiTiepNhan":
          return this.buildTuChoiTiepNhan(object);
        case "chuyenTiepLanhDao":
          return this.buildChuyenTiep(object);
        default:
          return object.messageType;
      }
    },

    buildTuChoi(object) {
      return (
        "<div" +
        '        class="content"' +
        "      >" +
        "        <span>Ông/bà</span>" +
        "        <span" +
        '          class="highlight font-weight__bold"' +
        "        >" +
        object.fromUserName +
        "        </span>" +
        "        <span>đã</span>" +
        "        <span" +
        '          class="highlight-action"' +
        "        >" +
        this.getActionText(object.messageType) +
        "        </span>" +
        "        <span> văn bản </span>" +
        '        <span class="event ">"' +
        this.dataRow.object.quote +
        '"</span>' +
        "      </div>"
      );
    },

    buildCXL(object) {
      return (
        "<div" +
        '        class="content"' +
        "      >" +
        "        <span>Ông/bà</span>" +
        "        <span" +
        '          class="highlight font-weight__bold"' +
        "        >" +
        object.fromUserName +
        "        </span>" +
        "        <span>đã</span>" +
        "        <span" +
        '          class="highlight-action"' +
        "        >" +
        this.getActionText(object.messageType) +
        "        </span>" +
        "        <span> văn bản </span>" +
        '        <span class="event ">"' +
        this.dataRow.object.quote +
        '"</span>' +
        "      </div>"
      );
    },

    buildBHanh(object) {
      return (
        "<div" +
        '        class="content"' +
        "      >" +
        "        <span>" +
        "         <strong>" +
        object.fromUserName +
        "</strong> " +
        "        <span" +
        '          class="highlight-action"' +
        "        >" +
        this.getActionText(object.messageType) +
        "        </span>" +
        "         văn bản <strong>" +
        (this.dataRow.object.docCode
          ? "số " + this.dataRow.object.docCode
          : "") +
        "</strong> ngày <strong>" +
        this.formatDate(this.dataRow.object.docDate) +
        "</strong>" +
        "        </span>" +
        "        <span> về việc </span>" +
        '        <span>"' +
        this.dataRow.object.quote +
        '"</span>' +
        "      </div>"
      );
    },

    buildChuyenTiep(object) {
      return (
        "<div" +
        '        class="content"' +
        "      >" +
        "        <span>" +
        "         <strong>" +
        object.fromUserName +
        "</strong> " +
        "        <span" +
        '          class="highlight-action"' +
        "        >" +
        this.getActionText(object.messageType) +
        "        </span>" +
        "          văn bản <strong>" +
        (this.dataRow.object.docCode
          ? "số " + this.dataRow.object.docCode
          : "") +
        "</strong> ngày <strong>" +
        this.formatDate(this.dataRow.object.docDate) +
        "</strong>" +
        "        </span>" +
        "        <span> về việc </span>" +
        '        <span>"' +
        this.dataRow.object.quote +
        '"</span>' +
        "      </div>"
      );
    },

    buildTuChoiTiepNhan(object) {
      return (
        "<div" +
        '        class="content"' +
        "      >" +
        "        <span>" +
        "         <strong>" +
        object.fromUserName +
        "</strong> " +
        "        <span" +
        '          class="highlight-action"' +
        "        >" +
        this.getActionText(object.messageType) +
        "        </span>" +
        "         văn bản " +
        "         <strong>" +
        (this.dataRow.object.docCode
          ? "số " + this.dataRow.object.docCode
          : "") +
        "</strong>" +
        "         ngày " +
        "         <strong>" +
        this.formatDate(this.dataRow.object.docDate) +
        "</strong>" +
        "        </span>" +
        "        <span> về việc </span>" +
        '        <span class="event ">"' +
        this.dataRow.object.quote +
        '"</span>' +
        "      </div>"
      );
    },

    formatDate(value) {
      let date = new moment(value);

      return date.format("DD/MM/YYYY");
    },

    maskAsSeen() {
      let item = Object.assign(this.item);
      if (item.status !== "seen") {
        this.$store.commit("subCount");
        item.status = "seen";
        vbNotificationService.maskAsSeen(item);
      }
    },

    isDiscuss(item) {
      return this.DISCUSS_TYPE.indexOf(item.messageType) !== -1;
    },

    isLetter(item) {
      let info = JSON.parse(item.dataJson);
      return (
        this.LETTERS.indexOf(item.messageType) !== -1 ||
        this.LETTERS.indexOf(info.emailCode) !== -1
      );
    },

    viewDetailV2() {
      this.$store.commit("updateSeenNotifi", this.item);
      switch (this.item.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.CREATE:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.UPDATE:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.HUY:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.YCBS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.DK_DEADLINE:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.GIA_HAN:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.BAO_CAO:
          this.viewHcCommandsDetail();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.DANG_KY:
          this.viewHcDieuXeDetail();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.DANG_KY:
          this.viewHcCaseFlightDetail();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.DANG_KY:
          this.viewHcCaseHotelDetail();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.DANG_KY:
          this.viewHcCasePhongHopDetail();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.TU_CHOI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.DANG_KY:
          this.viewHcCaseSCNDetail();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNOTI:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_USERNOTI:
          this.viewNotificationV2();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.TAG_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPLY_COMMENT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.APPROVE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DECLINE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.SEND_APPROVE_DISCUSS:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.REPORT_COMMENT:
          this.viewDiscussV2();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DK_PHONGHOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.HUY_PHONG_HOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .CAP_NHAT_PHONG_HOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .PHE_DUYET_PHONG_HOP:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .TU_CHOI_PHONG_HOP:
          this.viewhanhChinhPHV2();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.DANG_KY:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.TU_CHOI:
          this.viewhanhChinhDXV2();
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .CAP_NHAT:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .HUY_YEU_CAU:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .PHE_DUYET:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .DANG_KY:
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .TU_CHOI:
          this.viewhanhChinhLTV2();
          break;
        default:
          if(this.isLetter(this.item)) this.viewLetterV2();
          this.viewDetail();
      }
    },

    viewNotificationV2() {
      this.maskAsSeen();
      this.viewNotification(this.item);
      this.$emit("hideNotify");
    },

    viewDiscussV2() {
      this.maskAsSeen();
      this.viewDiscuss(this.item);
      this.$emit("hideNotify");
    },

    viewLetterV2() {
      this.maskAsSeen();
      this.viewLetter(this.item);
      this.$emit("hideNotify");
    },

    viewhanhChinhPHV2() {
      this.maskAsSeen();
      this.viewHanhChinhPH(this.item);
      this.$emit("hideNotify");
    },

    viewhanhChinhDXV2() {
      this.maskAsSeen();
      this.viewHanhChinhDX(this.item);
      this.$emit("hideNotify");
    },

    viewhanhChinhLTV2() {
      this.maskAsSeen();
      this.viewHanhChinhLT(this.item);
      this.$emit("hideNotify");
    },

    viewDetail() {
      this.maskAsSeen();
      if (this.isViewTaskDetail(this.item)) {
        this.viewTaskDetail(this.item);
      } else if (this.isVbNotificationV2(this.item)) {
        this.viewDocDetailV2(this.item);
      } else {
        this.viewDocDetail(this.item);
      }
      this.$emit("hideNotify");
    },

    buildShortName(fullName) {
      return utils.buildShortName(fullName);
    },

    getActionText(action) {
      switch (action) {
        case "chuyenXuLy":
          return "Chuyển xử lý";
        case "chuyenTiep":
          return "Chuyển tiếp";
        case "thuHoi":
          return "Thu hồi";
        case "ketThuc":
          return "Ký duyệt";
        case "tuChoi":
          return "Từ chối";
        case "tuChoiBanHanh":
          return "Từ chối ban hành";
        case "banhanh":
          return "Ban hành";
        case "choBanHanh":
          return "Ký duyệt";
        case "CC":
          return "CC văn bản";
        case "chuyenTiepLanhDao":
          return "Chuyển tiếp";
        case constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN:
          return "Từ chối tiếp nhận";
        case constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI:
          return "Từ chối";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.scroll-area {
  max-height: 500px;
  height: auto;
  width: 100%;
  position: relative;
  margin: auto;
}

.userSegment {
  display: flex;
  align-items: center;
  line-height: initial;
  z-index: 2;
}

.profile {
  display: flex;
  margin: 0 24px 0 0;
}

.profile .thumbnail {
  width: 32px;
  height: 32px;
  background: #ddd;
  border-radius: 50%;
  margin: 0 8px 0 0;
}

.profile .txt {
}

.profile .txt .name {
  font-weight: 400;
  display: block;
}

.profile .txt .role {
  font-size: 12px;
}

.btnIcon {
  /* width: 32px;
            height: 32px;
            line-height: 32px; */
  text-align: center;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/notify-content.vue